<template>
    <div class="row" style="margin-top: 3px;" :id="this.oid">

        <!-- Option Properties -->
        <div class="col-md-4 quiz-left-column option-row"
             v-bind:class="{'text-success': isCorrect, 'text-danger': !isCorrect}">
            <input type="hidden" :name="'questions['+questionIdx+'][options]['+idx+'][oid]'" :value="oid"/>

            <i class="fa" v-bind:class="{'fa-check': isCorrect, 'fa-times': !isCorrect}"></i>
            <input type="hidden" :name="'questions['+questionIdx+'][options]['+idx+'][isCorrect]'" :value="isCorrect"/>
            <select v-model="isCorrect" title="isCorrect" style="width:90%;">
                <option :value="false">Incorrect</option>
                <option :value="true">Correct</option>
            </select>
            <br/>
            <button v-if="questionType==='freeText' && !isSuggestedAnswer && optionText.trim() !== ''"
                    type="button"
                    class="btn btn-default"
                    style="color:#444;"
                    @click="setSuggestedAnswer"
            >Set As Suggested Answer
            </button>
            <span v-if="isSuggestedAnswer" style="font-weight: bold; color:#444">Suggested Answer</span>
        </div>

        <!-- Option Text -->
        <div class="col-md-8 quiz-text-column option-row">
            <input type="hidden" :name="'questions['+questionIdx+'][options]['+idx+'][text][XX_en]'"
                   :value="optionText"/>
            <input type="text"
                   v-model="optionText"
                   dir="auto"
                   onfocus="preview(this.value);"
                   onkeyup="preview(this.value);"/>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            'iisCorrect': Boolean,
            'ioptionText': String,
            'idx': Number,
            'oid': String,
            'questionIdx': Number,
            'isSuggestedAnswer': Boolean,
            'questionType': String,
        },

        data: function() {
            return {
                isCorrect: this.iisCorrect,
                optionText: this.ioptionText ? this.ioptionText : '',
            };
        },

        methods: {
            setSuggestedAnswer() {
                this.$emit('setSuggestedAnswer', this.oid);
            },
        },
    };
</script>
